
// @ts-ignore
import anime from 'animejs';

import { getAll } from '../helpers/utilities';

declare global {
    interface Element { 
        fade_slide_up: FadeSlideUp;
    }
}

export class FadeSlideUp {
    private quick: boolean;
    private container: Element;
    private items: Element[];
    private observer: IntersectionObserver;
    public static itemClass = '.js-fade-slide-up__item';


    /**
     * Initialises a new instance of FadeSlideUp
     * 
     * @param container The root element for this block
     */
    constructor(container: Element) {
        this.container               = container;
        this.items                   = getAll(FadeSlideUp.itemClass, this.container) as Element[];
        this.container.fade_slide_up = this;
        this.quick                   = this.container.classList.contains('js-fade-slide-up--quick');

        // Show them when they come into view
        this.observer = new IntersectionObserver((entries) => {
            this.handleObserver(entries);
        }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });

        // Initially hide the items
        this.add(this.items);
    }


    /**
     * Add items to the observer
     * 
     * @param items The items to add
     */
    public add(items: Element[]) {
        if(!items) return;

        // Initially hide the items
        anime.set(items, {
            opacity: 0,
        });

        // Add them to the observer
        items.forEach(item => {
            this.observer.observe(item);
        });
    }


    /**
     * Handles our observer callback action
     * 
     * @param entries Our observer entries
     */
    private handleObserver(entries: IntersectionObserverEntry[]): void {
        entries.forEach(() => {
            const visibleEntries = entries.filter(item => item.intersectionRatio > 0.1);
            const visibleItems   = visibleEntries.map(item => item.target);
            
            // Animate them in
            anime({
                duration: this.quick ? 1000 : 3000,
                opacity: [0, 1],
                targets: visibleItems,
                translateY: this.quick ? ['10%', '0%'] : ['50%', '0%'],
                easing: 'easeOutQuint',
                delay: anime.stagger(100),
            });

            // Stop observing
            visibleItems.forEach(item => {
                this.observer.unobserve(item);
            });
        });
    }


    /**
     * Returns the FadeSlideUp class instance attached to the element
     * 
     * @param element The element to get the instance of
     */
    public static get_instance(element: Element): FadeSlideUp {
        return element.fade_slide_up;
    }
}
